import { render } from "./AlertElement.vue?vue&type=template&id=73abab36&scoped=true"
import script from "./AlertElement.vue?vue&type=script&lang=js"
export * from "./AlertElement.vue?vue&type=script&lang=js"

import "./AlertElement.vue?vue&type=style&index=0&id=73abab36&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73abab36"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QColor,QDialog});
